import React from 'react';
import { useIntl } from 'react-intl-next';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import searchBarMessages from '../search-bar/messages';
import messages from './messages';
import { IconButton, Input } from './styled';

export interface Props {
    id?: string;
    searchBarShown: boolean;
    term: string;
    onFocus?: () => void;
}

export const SearchTextbox = (props: Props) => {
    const { term, searchBarShown, onFocus, id: searchBarId = '' } = props;
    const { formatMessage } = useIntl();

    return (
        <>
            {searchBarShown && (
                <Box
                    xcss={xcss({
                        position: 'relative',
                    })}
                    id={searchBarId}
                >
                    <Input
                        type="text"
                        name={formatMessage(messages.inputLabel)}
                        aria-label={formatMessage(searchBarMessages.inputPlaceholder)}
                        autoComplete="off"
                        spellCheck={false}
                        placeholder={formatMessage(searchBarMessages.inputPlaceholder)}
                        defaultValue={term}
                        onFocus={onFocus}
                    />
                    <IconButton type="submit" actionSubjectId="search">
                        <SearchIcon
                            primaryColor={token('color.icon', colors.N200)}
                            label={formatMessage(messages.searchButton)}
                        />
                    </IconButton>
                </Box>
            )}
        </>
    );
};
